export enum RouteName {
  INDEX = 'index',

  // Lunchtool — mobile employee flow
  LOGIN = 'login',
  HOME = 'home',
  ORDER_DAY = 'order_day',
  ORDER_CONFIRMATION = 'order_confirmation',
  SETTINGS = 'settings',

  // Lunchtool — admin dashboard
  ADMIN_DASHBOARD = 'admin_dashboard',
  ADMIN_ROUNDS = 'admin_rounds',
  ADMIN_ROUND_DETAIL = 'admin_round_detail',
  ADMIN_ROUND_USER_DETAIL = 'admin_round_user_detail',
  ADMIN_CATERERS = 'admin_caterers',
  ADMIN_CATERER_MENU = 'admin_caterer_menu',
  ADMIN_OFFICES = 'admin_offices',
  ADMIN_OFFICE_DETAIL = 'admin_office_detail',
  ADMIN_USERS = 'admin_users',
  ADMIN_USER_DETAIL = 'admin_user_detail',
  ADMIN_ROLES = 'admin_roles',
  ADMIN_PRODUCT_LISTS = 'admin_product_lists',
  ADMIN_PRODUCT_LISTS_MENU = 'admin_product_lists_menu',
  ADMIN_DAY_PREFERENCES = 'admin_day_preferences',

  // Account / profile
  ACCOUNT_INFORMATION = 'account_information',

  NOT_FOUND = 'not_found',
}
